























import { Component, Vue, Inject } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class Page401 extends Vue {
  created() {
    
  }

  goBack() {
    this.$router.go(-1);
  }
}
